import { render, staticRenderFns } from "./page-comingsoon2.vue?vue&type=template&id=1cf9e6cc&"
import script from "./page-comingsoon2.vue?vue&type=script&lang=js&"
export * from "./page-comingsoon2.vue?vue&type=script&lang=js&"
import style0 from "./page-comingsoon2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports